import { AbstractQuery } from 'src/models/query';

export class GetTheIdoButtonForAnAggregateIdQuery extends AbstractQuery {
	name = 'IFS_IDO_Query_Queries_GetTheIdoButtonForAnAggregateIdQuery';
	sort = [];
	subscribeForUpdates = false;

	constructor(aggregateId: string) {
		super();
		this.parameters.push({ aggregateId: aggregateId });

		this.cacheable = false;
		this.ignoreCachedResult = true;
	}
}
